export const SHARED_SPACE_PATH = '/shared';

export const isSharedSpacePath = (pathname: string): boolean => {
  if (!pathname) return false;

  const cleaned = pathname.split('?')[0].split('#')[0].trim();
  const normalized = cleaned.length > 1 && cleaned.endsWith('/') ? cleaned.slice(0, -1) : cleaned;

  return normalized === SHARED_SPACE_PATH;
};

// Trailing slash matches `trailingSlash: true`; S3 redirects /shared → /shared/ and drops the query.
export const buildSharedSpaceUrl = (origin: string, token: string): string =>
  `${origin}${SHARED_SPACE_PATH}/?token=${encodeURIComponent(token)}`;
